export const itemFields = [
  {
    name: "itemCode",
    label: "Item Code",
    type: "text",
    required: true,
    readonly: true,
  },
  {
    name: "itemName",
    label: "Item Name",
    type: "text",
    required: true,
  },
  {
    name: "itemDescription",
    label: "Item Description",
    type: "textarea",
  },
 
  {
    name: "brand",
    label: "Item Brand",
    type: "text",
  },
  {
    name: "category",
    label: "Item Category",
    type: "selectCategory",
    required: true,
  },
  {
    name: "subCategory",
    label: "Item Sub-category",
    type: "selectSubCategory",
  },
 
  {
    name: "gtin",
    label: "GTIN / MPIN",
    type: "text",
  },
  {
    name: "uom",
    label: "UOM",
    type: "select",
    options: ["PCS", "KG", "LTR"],
    required: true,
  },
  {
    name: "condition",
    label: "Condition",
    type: "select",
    options: ["New", "Refurbished"],
    defaultValue: "New",
  },
  {
    name: "dimension",
    label: "Dimensions (L × B × H)",
    type: "dimension",
    fields: [
      { name: "length", label: "Length", type: "number" },
      { name: "breadth", label: "Breadth", type: "number" },
      { name: "height", label: "Height", type: "number" },
    ],
  },
  {
    name: "weight",
    label: "Weights",
    type: "select",
    fields: [
      { name: "grossWeight", label: "Gross Weight", type: "number" },
      { name: "netWeight", label: "Net Weight", type: "number" },
      { name: "tareWeight", label: "Tare Weight", type: "number" },
    ],
  },
 
  {
    name: "packagingInstructions",
    label: "Packaging Instructions",
    type: "text",
  },
 
 
  {
    name: "reorderPoint",
    label: "Reorder Point",
    type: "number",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: ["Active", "Inactive"],
    defaultValue: "Active",
  },
  {
    name: "returnable",
    label: "Returnable",
    type: "select",
    options:["yes","No"]
  },
  {
    name: "exchange",
    label: "Exchange",
    type: "select",
    options:["yes","No"]
  },
  {
    name: "fulfillmentFrom",
    label: "Fulfillment From",
    type: "multiselect",
    fetchFrom: "LOCATION_MASTER",
  },
   {
    name: "images",
    label: "Images",
    type: "images",
    helperText: "As per marketplace requirement",
  }
];
